import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom'

import { useLogout, useMe, useWallet } from '../api/hooks'
import { Button, Spinner } from './ui'

function navClass({ isActive }: { isActive: boolean }) {
  return `rounded-lg px-3 py-1.5 text-sm font-medium transition ${
    isActive ? 'bg-brand-soft text-brand' : 'text-muted hover:text-ink'
  }`
}

export default function Layout() {
  const { data: user, isPending } = useMe()
  const logout = useLogout()
  const navigate = useNavigate()
  // Skipped entirely when signed out, where it would only ever 401.
  const { data: wallet } = useWallet(Boolean(user))

  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-10 border-b border-border-subtle bg-canvas/85 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center gap-2 px-4 py-3">
          <Link to="/" className="mr-2 text-lg font-semibold tracking-tight">
            Lingo<span className="text-brand">Forge</span>
          </Link>

          <nav className="flex items-center gap-1">
            {user && (
              <NavLink to="/" end className={navClass}>
                My languages
              </NavLink>
            )}
            <NavLink to="/browse" className={navClass}>
              Browse
            </NavLink>
            {user && (
              <NavLink to="/arcade" className={navClass}>
                Arcade
              </NavLink>
            )}
          </nav>

          <div className="ml-auto flex items-center gap-2">
            {isPending ? null : user ? (
              <>
                {/* The balance lives in the header because it is earned all
                    over the app and spent in one place. */}
                <Link
                  to="/arcade"
                  className="flex items-center gap-1 rounded-lg px-2 py-1 text-sm
                    tabular-nums transition hover:bg-brand-soft"
                  title="Tokens"
                >
                  <span aria-hidden>🪙</span>
                  <span className="font-medium">{wallet?.balance ?? user.tokens}</span>
                </Link>
                <span className="hidden text-sm text-muted sm:inline">
                  {user.display_name}
                </span>
                <Button
                  variant="ghost"
                  onClick={() =>
                    logout.mutate(undefined, { onSuccess: () => navigate('/login') })
                  }
                >
                  Sign out
                </Button>
              </>
            ) : (
              <>
                <Link to="/login">
                  <Button variant="ghost">Sign in</Button>
                </Link>
                <Link to="/register">
                  <Button>Get started</Button>
                </Link>
              </>
            )}
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-4 py-8">
        {isPending ? <Spinner /> : <Outlet />}
      </main>
    </div>
  )
}
